import React from "react";
import { styled, css } from "styled-components";
import Colors from "../../styles/Colors";
import rem from "../../utils/rem";
const StyledLabel = styled.label `
  display: block;
  color: ${(props) => props.textColor ? Colors[props.textColor] : Colors.GRAY_DARKEST};
  font-weight: 500;
  margin: 0;
  line-height: 1.5;
  ${({ size }) => size === "large" &&
    css `
      font-size: ${rem(16)};
      letter-spacing: ${rem(0.4)};
    `}
  ${({ size }) => size === "medium" &&
    css `
      font-size: ${rem(14)};
      letter-spacing: ${rem(0.4)};
    `}
    ${({ size }) => size === "small" &&
    css `
      font-size: ${rem(12)};
    `}
`;
const StyledLabelSpan = styled.span `
  ${({ required }) => required &&
    css `
      &::after {
        content: "*";
        color: ${Colors.ALERT_ERROR};
      }
    `}
`;
const Label = ({ as, textColor, required, children, label, size = "large", ...props }) => (React.createElement(StyledLabel, { textColor: textColor, as: as, size: size, ...props },
    label && React.createElement(StyledLabelSpan, { required: required }, label),
    children));
export default Label;
//# sourceMappingURL=Label.js.map